    <div class="relative">
        <corp-control-title [corp-title]="corpLabel" [corp-size]="corpSize" [corp-disabled]="disabled"></corp-control-title>
        <textarea
            class="corp-control h-[140px]"
            [ngClass]="[
                        'corp-control-' + corpSize,
                        (ngControl?.invalid && (ngControl?.touched || ngControl?.dirty)) ? 'border-red-500' : ''
                    ]"
            [value]="value"
            (input)="onInput($event)"
            (blur)="onTouched()"
            [disabled]="disabled || corpLoading"
            [readonly]="corpReadonly">
        </textarea>
        @if(corpLoading) {
            <corp-spinner
                class="absolute right-2 top-[70%] -translate-y-1/2"
                [active]="true"
                color="text-primary-500"
                size="sm"
                [percentArc]="0.5">
            </corp-spinner>
        }

        @if(corpIcon) {
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pt-2 pl-1">
                <!-- <svg-icon [name]='corpIcon' svgClass="h-8 w-8"></svg-icon> -->
            </div>
        }
    </div>